/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 24/05/2022.
 */
import React, { useRef } from 'react'
import { graphql, Link } from 'gatsby'
import Button from '../components/Button'
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image'
import { animated, useSpring } from '@react-spring/web'
import KitchenPriceList from '../components/koekken/KitchenPriceList'
import KitchenTemplateGallery from '../components/koekken/KitchenTemplateGallery.js'
import KitchenCarousel from '../components/koekken/KitchenCarousel'
import KitchenInfo from '../components/koekken/KitchenInfo'
import KitchenMaterial from '../components/koekken/KitchenMaterial'
import MoreCollections from '../components/MoreCollections'
import HowTo from '../HowTo'
import ClientGallery from '../components/koekken/ClientGallery'
import { PriceBox } from '../components/PriceBox'
//
// this is a single model - not the list of products
//

export const Head = ({ data }) => {
  const seoTitle = data?.product?.seo || '-'
  return (
    <>
      <title>{seoTitle}</title>
      <html lang="da-DK " />
      <meta name="description" content={'Bedre på alle fronter'} />
      <meta name="og:title" content={seoTitle} />
    </>
  )
}

const KoekkenTemplate = ({ data }) => {
  const { product, metodPrices, background } = data

  const { price } = product
  const materiale = product.materiale
  const priceRef = useRef()

  const image = getImage(product.image)
  const mobileImage = getImage(product.mobile)

  const scrollToPrices = (event) => {
    priceRef.current.scrollIntoView({ behavior: 'smooth' })
  }

  const [props] = useSpring(
    () => ({
      from: { opacity: 0, y: -30 },
      to: { opacity: 1, y: 0 },
      delay: 400,
    }),
    []
  )

  return (
    <>
      <div
        className="container-fluid "
        style={{
          background: '#f8f8f8',
          minHeight: 650,
          maxHeight: 800,
          height: '80vh',
        }}
      >
        <div className="container h-100 px-0 ">
          <div className="row h-100 ">
            <div className="col-12 px-0 h-100 d-flex align-items-end position-relative ">
              {/* ----------- ------------------------------- */}
              {/* ----------- DESKTOPM PRICE TAG ------------ */}
              {/* ----------- ------------------------------- */}
              <div
                className="d-none d-md-block position-absolute bg-white "
                style={{ bottom: 0, right: 0, zIndex: 1, boxShadow: '0px 5px 12px -5px rgba(0, 0, 0, 0.081)' }}
              >
                <div className="d-flex px-4 pb-3 pt-4 h-100 w-100 align-items-center justify-content-between  ">
                  <PriceBox price={price}></PriceBox>
                  <Button onClick={scrollToPrices} title="Se priser" className="px-3"></Button>
                </div>
              </div>

              <div className="position-absolute w-100 " style={{ top: 0, left: 0, zIndex: 1, height: '50%' }}>
                <animated.div
                  className="w-100 d-flex justify-content-center align-items-center "
                  style={{ ...props, height: '100%' }}
                >
                  <div className="mt-0 ">
                    <h2 className="fw-bold text-center mb-4" style={{ color: background }}>
                      {product.name}
                    </h2>
                    <h6 className="text-center px-4 mb-4 " style={{ lineHeight: '150%' }}>
                      <span className="  ">{materiale}</span>
                    </h6>
                  </div>
                </animated.div>
              </div>
              {/* ------------------- */}
              {/* --- desktop IMAGE -- */}
              {/* ------------------- */}
              <div className="w-100 d-none d-md-block">
                <GatsbyImage
                  image={image}
                  alt={product.name}
                  imgStyle={{ objectPosition: '50% 100%', objectFit: 'contain' }}
                />
              </div>
              {/* ------------------- */}
              {/* --- MOBILE IMAGE -- */}
              {/* ------------------- */}
              <div className="w-100 d-block d-md-none">
                <GatsbyImage
                  image={mobileImage}
                  className=""
                  alt={product.name}
                  imgStyle={{ objectPosition: '50% 0%', objectFit: 'contain' }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid pb-md-7 pb-6 " style={{ background: '#efefef' }}>
        {/*MOBIL PRICE TAG*/}
        <div className="row d-block d-md-none border-bottom" style={{}}>
          <div className="col-12 px-0 bg-white" style={{ boxShadow: '0px 5px 12px -5px rgba(0, 0, 0, 0.081)' }}>
            <div className="d-flex h-100 w-100 align-items-center justify-content-between px-3 py-4" style={{}}>
              <PriceBox price={price}></PriceBox>
              <Button onClick={scrollToPrices} title="Se priser" className="px-3"></Button>
            </div>
          </div>
        </div>

        <div className="container px-0 pt-2 pt-md-5 ">
          <KitchenInfo product={product}></KitchenInfo>
        </div>
        <div className="container px-0 mt-4 ">
          <KitchenTemplateGallery gallery={product.gallery} product={product}></KitchenTemplateGallery>
        </div>
      </div>

      {/*<MasoneryGrid gallery={product.clientGallery}></MasoneryGrid>*/}

      {product.clientGallery.length > 0 ? <ClientGallery gallery={product.clientGallery}></ClientGallery> : null}

      <KitchenMaterial></KitchenMaterial>

      {/*<div className="container-fluid bg-black py-4  ">
        <TestimonialToke></TestimonialToke>
      </div>*/}
      <HowTo></HowTo>

      <KitchenPriceList metodPrices={metodPrices} priceRef={priceRef} product={product}></KitchenPriceList>

      <div className="container-fluid bg-white">
        <div className="container pt-6 ">
          <div className="row" style={{}}>
            <div className="col-12  d-flex justify-content-center">
              <div className="my-5">
                <p className="mb-md-2 mb-1 text-center opacity-75">Fuldend udtrykket</p>
                <h3 className="fw-bold mb-4 text-center">Suppler dit køkken med træskuffer</h3>
                <div className="d-flex justify-content-center">
                  <Link to="/skuffer">
                    <Button className="mt-2 mx-1 " style={{ width: 120 }} title="Læs mere"></Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="row " style={{}}>
            <div className="col-12 mt-5">
              <StaticImage
                className=""
                objectFit=""
                src="../images/drawer/drawer_001.png"
                objectPosition="0% 0%"
                alt="skuffer"
                quality={100}
              ></StaticImage>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid py-5 bg-white">
        <div className="container  ">
          <div className="row my-6 position-relative" style={{}}>
            <KitchenCarousel title="Se flere modeller"></KitchenCarousel>
          </div>
        </div>
      </div>
      <MoreCollections></MoreCollections>
    </>
  )
}

export const query = graphql`
  query KitchenProduct($productId: String, $hackkId: String) {
    allProducts: allMetodProductsJson {
      edges {
        node {
          id
          name
          type

          gallery {
            publicURL
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }

          icon {
            publicURL
          }
        }
      }
    }

    product: metodProductsJson(id: { eq: $productId }) {
      id
      name
      type
      text
      materiale
      background
      typeText
      seo
      price {
        group
        txt
        example
        extra
        ikeaExample
      }
      icon {
        publicURL
      }
      image {
        publicURL
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, width: 3601)
        }
      }
      mobile {
        publicURL
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, width: 3601)
        }
      }

      listImage {
        publicURL
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }

      clientGallery {
        images {
          publicURL
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
          }
        }
      }

      gallery {
        publicURL
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        }
      }
    }

    metodPrices: metodProductPricesJson(productId: { eq: $hackkId }) {
      id
      productId

      data {
        title
        oak_veneer_metod
        linoleum_oak_metod
        linoleum_smooked_oak_metod
        linoleum_wallnut_metod
        painted_metod
        wallnut_veneer_metod
        smooked_oak_veneer_metod
      }
    }

    extraPrices: allExtrasJson {
      edges {
        node {
          data {
            price
            size
            title
            name
          }
          type
          detail
        }
      }
    }
  }
`

export default KoekkenTemplate
